var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 7,
    x2: 57,
    y1: 9,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "case",
    x1: 14,
    x2: 50,
    y1: 19,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    d: "M25 13h14c3 0 5 2 5 5v4h-6v-3H26v3h-6v-4c0-3 2-5 5-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#case)",
    stroke: "#EF4444",
    strokeWidth: 3,
    d: "M14 23h36c3 0 5 2 5 5v20c0 3-2 5-5 5H14c-3 0-5-2-5-5V28c0-3 2-5 5-5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4444",
    d: "M28 30h8v6h6v8h-6v6h-8v-6h-6v-8h6v-6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#60A5FA",
    d: "M44 16c4 0 7 3 7 7 0 2-1 4-3 5l-9-9c1-2 3-3 5-3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "m39 19 9 9c-3 3-7 3-10 0s-3-7 1-9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.972714ef1a5fc280b035eee046943a6d.svg";
export { ForwardRef as ReactComponent };